"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Search } from "lucide-react";

export const BlogHeader = () => {
  const [visible, setVisible] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    if (latest > 100) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  });

  return (
    <motion.header
      initial={{ y: 0 }}
      animate={{ 
        y: 0,
        backgroundColor: visible ? "rgba(9, 9, 11, 0.8)" : "transparent",
        backdropFilter: visible ? "blur(12px)" : "none",
        borderBottom: visible ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid transparent"
      }}
      className="fixed top-0 inset-x-0 z-[100] transition-colors duration-300"
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link href="/" className="flex items-center group transition-opacity hover:opacity-80" aria-label="Tavlo - Home">
            <Image
              src="/logo-light.png"
              alt="Tavlo"
              width={110}
              height={40}
              style={{
                filter: "brightness(5) saturate(0.5)",
              }}
            />
          </Link>
          
          <nav className="hidden md:flex items-center gap-6">
            <Link 
              href="/blog" 
              className="text-sm font-bold text-white/60 hover:text-white transition-colors flex items-center gap-2"
            >
              Blog
            </Link>
          </nav>
        </div>

        <div className="flex items-center gap-4">
          <button className="p-2 text-white/60 hover:text-white transition-colors hidden sm:block">
            <Search className="w-5 h-5" />
          </button>
          
          <Link href="/sign-in">
            <Button 
              size="sm"
              className="bg-brand-1 text-white hover:bg-brand-2 rounded-full px-6 font-bold text-xs uppercase tracking-widest h-10"
            >
              Try for free <ArrowRight className="w-3 h-3 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </motion.header>
  );
};

export default BlogHeader;
